import { CustomVizOptionsSummaryDropdown } from 'libs/end-to-end/src/custom-viz/CustomVizDefinitions';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { CustomVizEventProperties } from 'libs/end-to-end/src/analytics/CustomVizEventProperties';
import { lookupCustomVizDefinition } from 'libs/end-to-end/src/custom-viz/CustomVizDefinitions';

export interface DropdownItem {
  optionLabel: string;
  optionValue: string;
}

export const mapItems = (props: {
  options: CustomVizOptionsSummaryDropdown[];
  dropdownId: string;
  sortValuesFn?: (a: string, b: string) => number;
  filterNulls?: boolean;
}): DropdownItem[] => {
  const { options, dropdownId, sortValuesFn, filterNulls } = props;

  const items = options
    .filter(
      (dropdownOption) =>
        dropdownOption.dropdownId === dropdownId &&
        (filterNulls ? dropdownOption.dropdownItemValue !== 'null' : true),
    )
    .map((dropdownOption) => ({
      optionValue: dropdownOption.dropdownItemValue,
      optionLabel: dropdownOption.dropdownItemValue,
    }));

  if (sortValuesFn) {
    items.sort((a, b) => sortValuesFn(a.optionValue, b.optionValue));
  }

  return items;
};

export const getNewItems = (props: {
  options: CustomVizOptionsSummaryDropdown[];
  dropdownId: string;
  sortValuesFn?: (a: string, b: string) => number;
  filterNulls?: boolean;
}) => {
  const { options, dropdownId, sortValuesFn, filterNulls } = props;

  const newItems = options
    .filter(
      (option) =>
        option.dropdownId === dropdownId &&
        (filterNulls ? option.dropdownItemValue !== 'null' : true),
    )
    .map((option) => option.dropdownItemValue);

  if (sortValuesFn) {
    newItems.sort(sortValuesFn);
  }

  return newItems;
};

export const checkCanAnalyze = (props: {
  status: string;
  /**
   * If using the filters dropdowns, validates that all filters have at least one value selected
   */
  filters?: string[][];
  /**
   * If using the filtersForExtras instead of dropdowns, validates that all filters have at least one value selected
   */
  filtersForExtras?: FilterDefinitionForExtras[];
}) => {
  const { status, filters, filtersForExtras } = props;

  // check if any filter is empty
  if (filters?.some((filter) => filter.length === 0)) {
    return false;
  }

  if (filtersForExtras?.some((filter) => filter.values.length === 0)) {
    return false;
  }

  return status === 'waiting-for-user';
};

// eslint-disable-next-line complexity
export const mapCustomVizRequestToAnalyticsEventProperties = ({
  request,
}: {
  request: CustomVizRequest;
}): CustomVizEventProperties => {
  return lookupCustomVizDefinition(request.customVizId).eventProperties(
    request,
  );
};
